import { render, staticRenderFns } from "./OdApiSettings.vue?vue&type=template&id=5b8ecf23&scoped=true"
import script from "./OdApiSettings.vue?vue&type=script&lang=js"
export * from "./OdApiSettings.vue?vue&type=script&lang=js"
import style0 from "./OdApiSettings.vue?vue&type=style&index=0&id=5b8ecf23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ecf23",
  null
  
)

export default component.exports